<div class="w-full py-3 px-2 sm:px-4">
  <div class="md:flex items-center justify-between mb-4">

    <!-- LEFT SIDE -->
    <div class="flex items-center gap-1 lg:gap-2">

      <!-- Back Button -->
      <svg class="size-6 cursor-pointer" [routerLink]="['/product-tagging']" viewBox="0 0 24 24" fill="none"
        xmlns="http://www.w3.org/2000/svg">

        <mask id="mask0_848_1764" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="24" height="24">
          <rect width="24" height="24" fill="#C19725" />
        </mask>

        <g mask="url(#mask0_848_1764)">
          <path d="M16 22L6 12L16 2L17.775 3.775L9.55 12L17.775 20.225L16 22Z" fill="#C19725" />
        </g>
      </svg>

      <img class="size-6 sm:size-8 lg:size-10" src="/assets/images/stock/ready-product.png" alt="user" />

      <span class="font-semibold text-sm sm:text-base lg:text-xl text-444">
        BAR-CODE PRINT PANEL
      </span>
    </div>

    <!-- RIGHT SIDE -->
    <div class="flex items-center gap-2">
      <button (click)="openPrinterModal()"
        class="cursor-pointer bg-[#C19725] hover:bg-[#a87f1f] text-white px-4 py-2 rounded-md shadow text-sm font-medium transition">
        MANAGE PRINTERS
      </button>
      <button (click)="openTemplateModal()"
        class="cursor-pointer bg-[#C19725] hover:bg-[#a87f1f] text-white px-4 py-2 rounded-md shadow text-sm font-medium transition">
        ADD TEMPLATE
      </button>
    </div>

  </div>
  <form [formGroup]="barcodeSettingsForm" (ngSubmit)="onSettingsSubmit()">
    <div class="w-full py-3 bg-blue-100 rounded-md">
      <div
        class="w-full px-3 grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-6 2xl:grid-cols-11 gap-2">
        <div class="col-span-1">
          <div class="relative">
            <input type="text" id="label-top-margin" formControlName="topMargin" autocomplete="off"
              (keydown.enter)="focusNext($event)"
              class="block px-2 py-2 w-full text-sm lg:text-sm text-444 font-normal bg-white rounded-md border-1 border-dcdcdc appearance-none focus:outline-none focus:ring-0 focus:border-c19725 peer"
              placeholder=" " />
            <label for="label-top-margin"
              class="absolute text-sm lg:text-sm text-[#898989] duration-300 transform -translate-y-4 scale-75 top-2 z-0 origin-[0] bg-white px-1.5 peer-focus:px-1.5 peer-focus:text-c19725 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 rtl:peer-focus:translate-x-1/4 rtl:peer-focus:left-auto start-1">Top
              Margin
            </label>
          </div>
        </div>

        <div class="col-span-1">
          <div class="relative">
            <input type="text" id="label-left-margin" formControlName="leftMargin" autocomplete="off"
              (keydown.enter)="focusNext($event)"
              class="block px-2 py-2 w-full text-sm lg:text-sm text-444 font-normal bg-white rounded-md border-1 border-dcdcdc appearance-none focus:outline-none focus:ring-0 focus:border-c19725 peer"
              placeholder=" " />
            <label for="label-left-margin"
              class="absolute text-sm lg:text-sm text-[#898989] duration-300 transform -translate-y-4 scale-75 top-2 z-0 origin-[0] bg-white px-1.5 peer-focus:px-1.5 peer-focus:text-c19725 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 rtl:peer-focus:translate-x-1/4 rtl:peer-focus:left-auto start-1">Left
              Margin
            </label>
          </div>
        </div>

        <div class="col-span-1">
          <div class="relative">
            <input type="text" id="label-tail-length" formControlName="tailLength" autocomplete="off"
              (keydown.enter)="focusNext($event)"
              class="block px-2 py-2 w-full text-sm lg:text-sm text-444 font-normal bg-white rounded-md border-1 border-dcdcdc appearance-none focus:outline-none focus:ring-0 focus:border-c19725 peer"
              placeholder=" " />
            <label for="label-tail-length"
              class="absolute text-sm lg:text-sm text-[#898989] duration-300 transform -translate-y-4 scale-75 top-2 z-0 origin-[0] bg-white px-1.5 peer-focus:px-1.5 peer-focus:text-c19725 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 rtl:peer-focus:translate-x-1/4 rtl:peer-focus:left-auto start-1">Tail
              Length
            </label>
          </div>
        </div>

        <!-- TAIL SIDE: Now visible for all templates -->
        <div class="col-span-1">
          <div class="relative">
            <select autocomplete="off" (keydown.enter)="focusNext($event)" id="label-tail-side"
              formControlName="tailSide"
              class="block px-2 py-2 w-full text-sm lg:text-sm text-444 font-normal bg-white rounded-md border-1 border-dcdcdc appearance-none focus:outline-none focus:ring-0 focus:border-c19725 peer">
              <option value="none">None</option>
              <option value="left">Left</option>
              <option value="right">Right</option>
            </select>
            <label for="label-tail-side"
              class="absolute text-sm lg:text-sm text-[#898989] duration-300 transform -translate-y-4 scale-75 top-2 z-0 origin-[0] bg-white px-1.5 peer-focus:px-1.5 peer-focus:text-c19725 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 rtl:peer-focus:translate-x-1/4 rtl:peer-focus:left-auto start-1">
              Tail Side
            </label>
          </div>
        </div>

        <!-- NEW TEMPLATE TYPE DROPDOWN -->
        <div class="col-span-1">
          <div class="relative">
            <select autocomplete="off" (keydown.enter)="focusNext($event)" id="label-template-type"
              formControlName="templateType"
              class="block px-2 py-2 w-full text-sm lg:text-sm text-444 font-normal bg-white rounded-md border-1 border-dcdcdc appearance-none focus:outline-none focus:ring-0 focus:border-c19725 peer"
              placeholder=" " (change)="onTemplateTypeChange(false)">
              <!-- <option value="$custom">Custom Size</option>
              <option value="$100mmx15mm">100mm X 15mm</option>
              <option value="$25mmx25mm">25mm X 25mm</option>
              <option value="$50mmx25mm">50mm X 25mm</option>
              <option value="$40mmx20mm">40mm X 20mm</option> -->
              <option value="" selected hidden disabled>Select Type</option>
              <option *ngFor="let t of dbTemplates" [value]="t.slug">{{ t.name }}</option>

            </select>
            <label for="label-template-type"
              class="absolute text-sm lg:text-sm text-[#898989] duration-300 transform -translate-y-4 scale-75 top-2 z-0 origin-[0] bg-white px-1.5 peer-focus:px-1.5 peer-focus:text-c19725 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 rtl:peer-focus:translate-x-1/4 rtl:peer-focus:left-auto start-1">Template
              Type
            </label>
          </div>
        </div>

        <div class="col-span-1">
          <div class="relative">
            <input type="text" id="label-width" formControlName="labelWidth" autocomplete="off"
              (keydown.enter)="focusNext($event)"
              class="block px-2 py-2 w-full text-sm lg:text-sm text-444 font-normal bg-white rounded-md border-1 border-dcdcdc appearance-none focus:outline-none focus:ring-0 focus:border-c19725 peer"
              placeholder=" " />
            <label for="label-width"
              class="absolute text-sm lg:text-sm text-[#898989] duration-300 transform -translate-y-4 scale-75 top-2 z-0 origin-[0] bg-white px-1.5 peer-focus:px-1.5 peer-focus:text-c19725 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 rtl:peer-focus:translate-x-1/4 rtl:peer-focus:left-auto start-1">Label
              Width
            </label>
          </div>
        </div>

        <div class="col-span-1">
          <div class="relative">
            <input type="text" id="label-height" formControlName="labelHeight" autocomplete="off"
              (keydown.enter)="focusNext($event)"
              class="block px-2 py-2 w-full text-sm lg:text-sm text-444 font-normal bg-white rounded-md border-1 border-dcdcdc appearance-none focus:outline-none focus:ring-0 focus:border-c19725 peer"
              placeholder=" " />
            <label for="label-height"
              class="absolute text-sm lg:text-sm text-[#898989] duration-300 transform -translate-y-4 scale-75 top-2 z-0 origin-[0] bg-white px-1.5 peer-focus:px-1.5 peer-focus:text-c19725 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 rtl:peer-focus:translate-x-1/4 rtl:peer-focus:left-auto start-1">Label
              Height
            </label>
          </div>
        </div>

        <div class="col-span-1">
          <div class="relative">
            <select autocomplete="off" (keydown.enter)="focusNext($event)" type="text" id="label-text-align"
              formControlName="textAlign"
              class="block px-2 py-2 w-full text-sm lg:text-sm text-444 font-normal bg-white rounded-md border-1 border-dcdcdc appearance-none focus:outline-none focus:ring-0 focus:border-c19725 peer"
              placeholder=" ">
              <option value="left">Left</option>
              <option value="center">Center</option>
              <option value="right">Right</option>
              <option value="none">None</option>
            </select>
            <label for="label-text-align"
              class="absolute text-sm lg:text-sm text-[#898989] duration-300 transform -translate-y-4 scale-75 top-2 z-0 origin-[0] bg-white px-1.5 peer-focus:px-1.5 peer-focus:text-c19725 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 rtl:peer-focus:translate-x-1/4 rtl:peer-focus:left-auto start-1">
              Text Align
            </label>
          </div>
        </div>

        <div class="col-span-1">
          <div class="relative">
            <input type="text" id="label-barcode-size" formControlName="barcodeSize" autocomplete="off"
              (keydown.enter)="focusNext($event)"
              class="no-spinner block px-2 py-2 w-full text-sm lg:text-sm text-444 font-normal bg-white rounded-md border-1 border-dcdcdc appearance-none focus:outline-none focus:ring-0 focus:border-c19725 peer"
              placeholder=" " />
            <label for="label-barcode-size"
              class="absolute text-sm lg:text-sm text-[#898989] duration-300 transform -translate-y-4 scale-75 top-2 z-0 origin-[0] bg-white px-1.5 peer-focus:px-1.5 peer-focus:text-c19725 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 rtl:peer-focus:translate-x-1/4 rtl:peer-focus:left-auto start-1">Barcode
              Size</label>
          </div>
        </div>
        <!-- Inside the barcodeSettingsForm div grid -->
        <div class="col-span-1">
          <div class="relative">
            <select id="printer-dpi" formControlName="printerDpi"
              class="block ps-2 pe-7 py-2 w-full text-sm text-444 font-normal bg-white rounded-md border-1 border-dcdcdc focus:outline-none focus:ring-0 focus:border-c19725 peer">
              <option value="203">203 DPI (Standard)</option>
              <option value="300">300 DPI (High Res)</option>
              <option value="600">600 DPI (Ultra)</option>
            </select>
            <label for="printer-dpi"
              class="absolute text-sm text-[#898989] duration-300 transform -translate-y-4 scale-75 top-2 bg-white px-1.5 peer-focus:px-1.5 peer-focus:text-c19725 peer-focus:-translate-y-4">
              Printer Resolution
            </label>
          </div>
        </div>

        <!-- <div class="col-span-1">
          <div
            class="flex items-center justify-start px-2 py-2 w-full text-sm lg:text-sm text-444 font-normal bg-transparent"
          >
            <input
              type="checkbox"
              formControlName="deleteAll"
              autocomplete="off"
              (keydown.enter)="focusNext($event)"
              class="cursor-pointer w-[18px] h-[18px] me-1 text-c19725 border-2 border-c19725 rounded focus:ring-1 focus:ring-[#757575]"
            />
            <span>Delete All</span>
          </div>
        </div> -->

        <!-- <div class="col-span-1">
          <div
            class="flex items-center justify-start px-2 py-2 w-full text-sm lg:text-sm text-444 font-normal bg-transparent"
          >
            <input
              type="checkbox"
              formControlName="generateBarcode"
              autocomplete="off"
              (keydown.enter)="focusNext($event)"
              class="cursor-pointer w-[18px] h-[18px] me-1 text-c19725 border-2 border-c19725 rounded focus:ring-1 focus:ring-[#757575]"
            />
            <span>Generate Barcode</span>
          </div>
        </div> -->

        <div class="col-span-1 mt-2 sm:mt-0 flex justify-center sm:justify-start">
          <button type="submit"
            class="block cursor-pointer capitalize w-full sm:w-[110px] lg:w-[150px] p-1.5 text-base font-bold text-white bg-c19725 border-1 border-c19725 hover:bg-fdffc6 hover:text-c19725 hover:shadow-lg focus:ring-0 focus:outline-none rounded-md text-center">
            Submit
          </button>
        </div>
      </div>
    </div>
  </form>

  <div class="mt-3 pt-2 py-3 px-3 bg-white border border-gray-200 rounded shadow">
    <form [formGroup]="fieldSettingsForm" (ngSubmit)="onSubmitFieldSettings()">
      <div cdkDropList cdkDropListOrientation="horizontal" [cdkDropListData]="fieldKeys"
        (cdkDropListDropped)="onFieldDrop($event)"
        class="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-6 2xl:grid-cols-9 gap-2 text-center py-1 bg-white">
        <div *ngFor="let key of fieldKeys" cdkDrag class="relative flex flex-col gap-y-2 cursor-move">
          <div class="text-xs font-semibold text-white py-2 bg-c19725 rounded-md" cdkDragHandle>
            {{ getLabel(key) }}
          </div>

          <div class="relative">
            <select [id]="key + '_visibility'" (change)="updateFieldVisibility(key, $any($event.target).value)"
              class="block px-2 py-2 w-full text-sm text-444 bg-white rounded-md border-1 border-dcdcdc">
              <option value="show" [selected]="fieldVisibility[key]">Show</option>
              <option value="hide" [selected]="!fieldVisibility[key]">Hide</option>
            </select>
          </div>

          <div class="relative">
            <input type="text" [id]="'label_input_' + key" [formControlName]="key + 'Label'"
              class="block px-2 py-2 w-full text-xs text-[#444] font-normal bg-white rounded-md border border-[#dcdcdc] appearance-none focus:outline-none focus:ring-0 focus:border-[#c19725] peer"
              placeholder=" " />
            <label [for]="'label_input_' + key"
              class="absolute text-xs text-[#898989] duration-300 transform -translate-y-4 scale-75 top-2 z-0 origin-[0] bg-white px-1.5 peer-focus:text-[#c19725] peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 start-1">
              Label
            </label>
          </div>

          <div class="relative">
            <input type="text" [id]="'size_input_' + key" [formControlName]="key + 'Size'"
              class="block px-2 py-2 w-full text-xs text-[#444] font-normal bg-white rounded-md border border-[#dcdcdc] appearance-none focus:outline-none focus:ring-0 focus:border-[#c19725] peer"
              placeholder=" " />
            <label [for]="'size_input_' + key"
              class="absolute text-xs text-[#898989] duration-300 transform -translate-y-4 scale-75 top-2 z-0 origin-[0] bg-white px-1.5 peer-focus:text-[#c19725] peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 start-1">
              Font Size
            </label>
          </div>
        </div>
      </div>

      <div class="flex justify-center mt-4">
        <button type="submit"
          class="cursor-pointer capitalize w-full sm:w-[150px] p-1.5 text-base font-bold text-white bg-c19725 border border-c19725 hover:bg-fdffc6 hover:text-c19725 hover:shadow-lg focus:ring-0 focus:outline-none rounded-md text-center">
          Submit
        </button>
      </div>
    </form>
  </div>
</div>

<!-- <div class="w-full py-3 px-2 sm:px-4 bg-blue-100">
  <form [formGroup]="searchForm" (ngSubmit)="onSearch()">
    <div class="flex flex-col sm:flex-row items-center justify-center gap-4">
      <div class="text-center sm:text-left">
        <span class="font-semibold text-sm sm:text-base lg:text-xl text-444">
          SEARCH PRODUCT BY BARCODE:
        </span>
      </div>

      <div class="relative w-full sm:w-auto" (focusin)="showDropdown = true" (focusout)="onBlurDropdown()">
        <input
          type="text"
          id="search-input"
          formControlName="searchInput"
          autocomplete="off"
          class="block px-2 py-2 w-full sm:w-[250px] text-sm lg:text-sm text-444 font-normal bg-white rounded-md border border-dcdcdc appearance-none focus:outline-none focus:ring-0 focus:border-c19725 peer"
          placeholder=" "
          (focus)="handleFocus()"
          (keydown)="onKeydown($event)"
        />
        <label
          for="search-input"
          class="absolute text-sm lg:text-sm text-[#898989] duration-300 transform -translate-y-4 scale-75 top-2 z-0 origin-[0] bg-white px-1.5 peer-focus:px-1.5 peer-focus:text-c19725 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 start-1"
        >
          All
        </label>

        <ul
          *ngIf="showDropdown && filteredOptions.length"
          class="absolute z-20 w-full mt-1 bg-white border border-gray-300 rounded-md shadow max-h-48 overflow-y-auto"
        >
        <li
          *ngFor="let option of filteredOptions; let i = index"
          [class.bg-gray-200]="i === selectedOptionIndex"
          (mousedown)="onSelectOption(option)"
          class="px-3 py-2 cursor-pointer hover:bg-gray-100"
        >
          {{ option }}
        </li>
        </ul>
      </div>

      <div class="w-full sm:w-auto flex justify-center">
        <button
          type="submit"
          class="cursor-pointer capitalize w-full sm:w-[150px] p-1.5 text-base font-bold text-white bg-c19725 border border-c19725 hover:bg-fdffc6 hover:text-c19725 hover:shadow-lg focus:ring-0 focus:outline-none rounded-md text-center"
        >
          Search
        </button>
      </div>
    </div>
  </form>
</div> -->

<!-- SEARCH SECTION -->
<div class="w-full py-3 px-2 sm:px-4 bg-blue-100 border-t border-b border-gray-200">

  <!-- TOGGLE SWITCH -->
  <div class="flex justify-end mb-2">
    <button (click)="toggleRangeMode()" class="text-xs font-bold text-blue-700 underline uppercase">
      {{ isRangeMode ? 'Switch to Single Search' : 'Switch to Range Search' }}
    </button>
  </div>

  <!-- SINGLE SEARCH FORM -->
  <form *ngIf="!isRangeMode" [formGroup]="searchForm" (ngSubmit)="onSearch()">
    <div class="flex flex-col sm:flex-row items-center justify-center gap-4">
      <div class="text-center sm:text-left">
        <span class="font-semibold text-sm sm:text-base lg:text-lg text-444 uppercase">
          SINGLE BARCODE SEARCH:
        </span>
      </div>

      <div class="relative w-full sm:w-auto" (focusin)="showDropdown = true" (focusout)="onBlurDropdown()">
        <input type="text" id="search-input" formControlName="searchInput" autocomplete="off"
          class="block px-2 py-2 w-full sm:w-[250px] text-sm text-444 bg-white rounded-md border border-dcdcdc focus:outline-none focus:border-c19725 peer"
          placeholder="Enter Barcode" (focus)="handleFocus()" (keydown)="onKeydown($event)" />
        <!-- Dropdown logic -->
        <ul *ngIf="showDropdown && filteredOptions.length"
          class="absolute z-20 w-full mt-1 bg-white border border-gray-300 rounded-md shadow max-h-48 overflow-y-auto">
          <li *ngFor="let option of filteredOptions; let i = index" [class.bg-gray-200]="i === selectedOptionIndex"
            (mousedown)="onSelectOption(option)" class="px-3 py-2 cursor-pointer hover:bg-gray-100 text-xs">
            {{ option }}
          </li>
        </ul>
      </div>

      <button type="submit"
        class="cursor-pointer w-full sm:w-[120px] p-2 text-sm font-bold text-white bg-c19725 rounded-md hover:shadow-lg">
        Search
      </button>
    </div>
  </form>

  <!-- RANGE SEARCH FORM -->
  <form *ngIf="isRangeMode" [formGroup]="rangeForm" (ngSubmit)="onRangeSearch()">
    <div class="flex flex-col sm:flex-row items-center justify-center gap-4">
      <div class="text-center sm:text-left">
        <span class="font-semibold text-sm sm:text-base lg:text-lg text-444 uppercase">
          RANGE BARCODE SEARCH:
        </span>
      </div>

      <div class="flex gap-2">
        <div class="relative">
          <input type="text" formControlName="fromBarcode"
            class="block px-2 py-2 w-[150px] text-sm bg-white rounded-md border border-dcdcdc focus:border-c19725"
            placeholder="From Barcode" />
        </div>
        <div class="flex items-center font-bold text-gray-500">TO</div>
        <div class="relative">
          <input type="text" formControlName="toBarcode"
            class="block px-2 py-2 w-[150px] text-sm bg-white rounded-md border border-dcdcdc focus:border-c19725"
            placeholder="To Barcode" />
        </div>
      </div>

      <button type="submit"
        class="cursor-pointer w-full sm:w-[150px] p-2 text-sm font-bold text-white bg-blue-600 rounded-md hover:shadow-lg">
        Fetch Range
      </button>
    </div>
  </form>
</div>

<!-- BARCODE DUMMY DESIGN -->
<div class="overflow-x-auto w-full mt-8">
  <div class="flex flex-wrap justify-center gap-6 mt-8 p-2 sm:p-0">
    <!-- Inside the tag loop -->
    <div *ngFor="let tag of tags; let i = index" class="flex items-center" [ngStyle]="barcodeContainerStyle">

      <!-- LEFT TAIL -->
      <div *ngIf="barcodeSettingsForm.get('tailSide')?.value === 'left'" [ngStyle]="tailStyle"></div>

      <div class="bg-white rounded-2xl shadow-md border border-gray-200 relative p-2 flex-grow" [ngStyle]="labelStyle"
        cdkDragBoundary>

        <!-- REMOVE BUTTON -->
        <button (click)="removeLabel(i)"
          class="absolute top-0 right-0 z-10 p-1 bg-red-500 text-white rounded-bl-lg no-print">
          <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path d="M6 18L18 6M6 6l12 12"></path>
          </svg>
        </button>

        <!-- Replace your current ng-container loop with this -->
        <ng-container>
          <!-- Inside your label div -->
          <div *ngFor="let key of fieldKeys" [hidden]="!fieldVisibility[key]" cdkDrag
            [cdkDragFreeDragPosition]="fieldPositions[key]" (cdkDragEnded)="onDragEnded($event, key)"
            [style.position]="'absolute'" [style.cursor]="'move'" [style.white-space]="'normal'"
            [style.word-break]="'break-word'" [style.max-width.px]="getRemainingWidth(key)"
            [ngStyle]="fieldStyles[key]">
            <span class="font-semibold" *ngIf="key !== 'barcode'">
              {{ getLabel(key) }}:
            </span>
            <span *ngIf="key !== 'barcode'">{{ formatValue(tags[0], key) }}</span>

            <!-- Barcode specific rendering -->
            <svg #barcodeCanvas *ngIf="key === 'barcode'"></svg>
          </div>
        </ng-container>
      </div>

      <!-- RIGHT TAIL -->
      <div *ngIf="barcodeSettingsForm.get('tailSide')?.value === 'right'" [ngStyle]="tailStyle"></div>
    </div>
  </div>
</div>

<div class="mt-6 flex flex-wrap items-center justify-center gap-4">
  <div class="w-full sm:w-auto flex justify-center">
    <button type="button" (click)="directPrint()"
      class="cursor-pointer capitalize w-full sm:w-[150px] lg:w-[200px] p-1.5 text-base font-bold text-white bg-blue-600 border border-blue-600 hover:bg-blue-700 hover:shadow-lg focus:ring-0 focus:outline-none rounded-md text-center">
      DIRECT -> PRINT (PDF)
    </button>
  </div>

  <!-- NEW BUTTON -->
  <div class="w-full sm:w-auto flex justify-center">
    <button type="button" (click)="printZplLabels()"
      class="cursor-pointer capitalize w-full sm:w-[150px] lg:w-[200px] p-1.5 text-base font-bold text-white bg-green-600 border border-green-600 hover:bg-green-700 hover:shadow-lg focus:ring-0 focus:outline-none rounded-md text-center">
      PRINT TAG
    </button>
  </div>
</div>

<!-- TEMPLATE NAME MODAL -->
<div *ngIf="showTemplateModal" class="fixed inset-0 bg-black/40 flex items-center justify-center z-50">

  <div class="bg-white w-[90%] sm:w-[400px] rounded-xl shadow-lg p-6 relative">

    <!-- Close Button -->
    <button (click)="closeTemplateModal()" class="cursor-pointer absolute top-3 right-3 z-20 w-7 h-7 flex items-center justify-center
         rounded-full bg-white/90 hover:bg-gray-100 text-gray-600 hover:text-red-500 shadow-md transition-all">
      ✕
    </button>

    <h2 class="text-lg font-bold mb-4 text-center text-c19725">
      Add Template Name
    </h2>

    <div class="relative mb-4">
      <input type="text" [(ngModel)]="templateName" placeholder="Enter Template Name"
        class="block w-full px-3 py-2 text-sm border border-gray-300 rounded-md focus:outline-none focus:border-c19725" />
    </div>

    <div class="flex justify-end gap-2">
      <button (click)="closeTemplateModal()" class="px-4 py-2 text-sm bg-gray-200 rounded-md hover:bg-gray-300">
        Cancel
      </button>

      <button (click)="saveTemplate()" class="px-4 py-2 text-sm bg-c19725 text-white rounded-md hover:bg-[#a87f1f]">
        Save
      </button>
    </div>

  </div>
</div>

<!-- PRINTER MANAGEMENT MODAL -->
<div *ngIf="showPrinterModal" class="fixed inset-0 bg-black/40 flex items-center justify-center z-50">
  <div class="bg-white w-[95%] sm:w-[600px] max-h-[85vh] overflow-y-auto rounded-xl shadow-lg p-6 relative">

    <!-- Close Button -->
    <button (click)="closePrinterModal()" class="cursor-pointer absolute top-3 right-3 z-20 w-7 h-7 flex items-center justify-center
         rounded-full bg-white/90 hover:bg-gray-100 text-gray-600 hover:text-red-500 shadow-md transition-all">
      ✕
    </button>

    <h2 class="text-lg font-bold mb-4 text-center text-blue-600">
      Manage Store Printers
    </h2>

    <!-- Printers List Section -->
    <div class="mb-6">
      <div class="flex items-center justify-between mb-2">
        <h3 class="text-sm font-bold text-gray-700 uppercase">Configured Printers</h3>
        <button (click)="showAddPrinterForm = !showAddPrinterForm"
          class="text-xs font-bold text-blue-600 hover:underline">
          {{ showAddPrinterForm ? 'Show Saved Printers' : '+ Add New Printer' }}
        </button>
      </div>

      <div *ngIf="!showAddPrinterForm">
        <div *ngIf="savedPrinters.length === 0" class="text-center py-4 text-sm text-gray-500 bg-gray-50 rounded-md">
          No printers configured for this firm. Click "+ Add New Printer" to add one.
        </div>
        <div *ngIf="savedPrinters.length > 0" class="flex flex-col gap-2">
          <div *ngFor="let p of savedPrinters"
            class="flex items-center justify-between p-3 bg-gray-50 rounded-md border border-gray-200">
            <div>
              <div class="font-semibold text-sm flex items-center gap-1">
                {{ p.printer_name }}
                <span *ngIf="p.is_default"
                  class="bg-green-100 text-green-800 text-[10px] px-1.5 py-0.5 rounded font-bold uppercase">Default</span>
              </div>
              <div class="text-xs text-gray-500">
                Language: {{ p.printer_language }} | Connection: {{ p.printer_connection }} | DPI: {{ p.printer_dpi }}
              </div>
            </div>
            <div class="flex gap-2">
              <button *ngIf="!p.is_default" (click)="makePrinterDefault(p.id)"
                class="text-xs bg-green-600 hover:bg-green-700 text-white px-2 py-1 rounded">
                Set Default
              </button>
              <button (click)="deletePrinterConfig(p.id)"
                class="text-xs bg-red-600 hover:bg-red-700 text-white px-2 py-1 rounded">
                Delete
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Form Section -->
    <div *ngIf="showAddPrinterForm" class="border-t pt-4">
      <form [formGroup]="printerFormGroup" (ngSubmit)="savePrinterConfig()">
        <h4 class="text-sm font-bold text-gray-700 mb-3">Add Printer Configuration</h4>

        <div class="grid grid-cols-1 sm:grid-cols-2 gap-3 mb-4">
          <!-- Printer Name -->
          <div>
            <label class="block text-xs font-bold text-gray-500 mb-1">Select OS Printer (Discovered)</label>
            <div class="flex gap-1">
              <select formControlName="printerName"
                class="block w-full px-2 py-1.5 text-sm border border-gray-300 rounded-md focus:outline-none">
                <option value="">-- Choose Printer --</option>
                <option *ngFor="let dp of discoveredPrinters" [value]="dp.name">{{ dp.displayName || dp.name }}</option>
              </select>
              <button type="button" (click)="discoverLocalPrinters()" [disabled]="isDiscovering"
                class="px-2 bg-gray-100 border border-gray-300 rounded hover:bg-gray-200">
                <span *ngIf="!isDiscovering">🔄</span>
                <span *ngIf="isDiscovering">...</span>
              </button>
            </div>
            <div class="mt-1">
              <input type="text" formControlName="printerName" placeholder="Or type custom printer name"
                class="block w-full px-2 py-1 text-xs border border-gray-300 rounded-md" />
            </div>
          </div>

          <!-- Language -->
          <div>
            <label class="block text-xs font-bold text-gray-500 mb-1">Printer Language</label>
            <select formControlName="printerLanguage"
              class="block w-full px-2 py-1.5 text-sm border border-gray-300 rounded-md">
              <option value="ZPL">ZPL (Zebra)</option>
              <option value="TSPL">TSPL (TSC / GPrinter)</option>
              <option value="ESC/POS">ESC/POS (Epson / Thermal Receipt)</option>
              <option value="CPCL">CPCL (Zebra Mobile)</option>
              <option value="PDF">PDF (Standard Spool / Image)</option>
            </select>
          </div>

          <!-- Connection -->
          <div>
            <label class="block text-xs font-bold text-gray-500 mb-1">Connection Type</label>
            <select formControlName="printerConnection"
              class="block w-full px-2 py-1.5 text-sm border border-gray-300 rounded-md">
              <option value="USB">USB / OS Spooler</option>
              <option value="NETWORK">TCP Network (LAN / Wi-Fi)</option>
              <option value="SERIAL">COM Serial Port</option>
            </select>
          </div>

          <!-- DPI -->
          <div>
            <label class="block text-xs font-bold text-gray-500 mb-1">Resolution (DPI)</label>
            <select formControlName="printerDpi"
              class="block w-full px-2 py-1.5 text-sm border border-gray-300 rounded-md">
              <option [value]="203">203 DPI</option>
              <option [value]="300">300 DPI</option>
              <option [value]="600">600 DPI</option>
            </select>
          </div>

          <!-- Address (Optional) -->
          <div *ngIf="printerFormGroup.get('printerConnection')?.value !== 'USB'">
            <label class="block text-xs font-bold text-gray-500 mb-1">
              {{ printerFormGroup.get('printerConnection')?.value === 'NETWORK' ? 'IP Address' : 'COM Port' }}
            </label>
            <input type="text" formControlName="printerAddress" placeholder="e.g. 192.168.1.100 or COM1"
              class="block w-full px-2 py-1.5 text-sm border border-gray-300 rounded-md" />
          </div>

          <!-- Port (Optional) -->
          <div *ngIf="printerFormGroup.get('printerConnection')?.value === 'NETWORK'">
            <label class="block text-xs font-bold text-gray-500 mb-1">Port</label>
            <input type="text" formControlName="printerPort" placeholder="9100"
              class="block w-full px-2 py-1.5 text-sm border border-gray-300 rounded-md" />
          </div>
        </div>

        <div class="mb-4 flex items-center">
          <input type="checkbox" formControlName="isDefault" id="is-default-checkbox"
            class="mr-2 rounded border-gray-300" />
          <label for="is-default-checkbox" class="text-sm font-bold text-gray-600">Set as Default Printer</label>
        </div>

        <div class="flex justify-end gap-2">
          <button type="button" (click)="showAddPrinterForm = false"
            class="px-4 py-2 text-sm bg-gray-200 rounded-md hover:bg-gray-300">
            Cancel
          </button>
          <button type="submit" class="px-4 py-2 text-sm bg-blue-600 text-white rounded-md hover:bg-blue-700">
            Save Printer
          </button>
        </div>
      </form>
    </div>

  </div>
</div>